import { THEME_COLORS } from '@getgreenline/shared'
import * as React from 'react'

interface IProps {
  value: string
  onChange: (newValue: string) => void
  onRemove: (e: React.MouseEvent<HTMLDivElement>) => void
}

export const InputWithCloseIcon: React.FC<IProps> = ({ value, onChange, onRemove }: IProps) => (
  <div className='form-group position-relative'>
    <input className='form-control pr-5' value={value} onChange={(e) => onChange(e.target.value)} />

    <div
      className='position-absolute'
      style={{ right: 0, top: '0.4em', cursor: 'pointer' }}
      onClick={onRemove}
    >
      <span className='mr-3 fa fa-times' style={{ color: THEME_COLORS.ACTIONS.dangerAlt }} />
    </div>
  </div>
)
